import React from 'react';
import styles from './DataGrid.styles';
import { WithStyles, withStyles } from '@material-ui/core';
import FormViewModal from 'components/common/Modals/FormViewModal';
import HyperLinkRenderer from './CustomRenderers/HyperLinkRenderer';
import { IColDef } from './DataGrid.properties';

interface IPopupContentRendererProps extends WithStyles<typeof styles> {
    popupText?: string;
    selectedData?: any;
    customRenderer(data: any): JSX.Element;
}

const PopupContentRenderer = ({
  customRenderer,
  selectedData,
  popupText,
  classes,
}: IPopupContentRendererProps) => {

  if (typeof customRenderer === 'function') return customRenderer(selectedData);

  return <div className={classes.commentStyles}>{popupText}</div>;
};

export const PopupDialog = ({ open, title, onOk, children }) => {
  return (<FormViewModal
    loading={false}
    open={open}
    title={title}
    dialogActionsButtons={true}
    dialogActionsShadow={false}
    actions={[
      {
        title: 'ok',
        isDefault: true,
        listener: () => {
          onOk?.();
        },
      },
    ]}
    modalContent={children} />);
};

export const HyperlinkCell = (row: any, col: IColDef) => {
  const params = col.hyperlinkParamGetter ? col.hyperlinkParamGetter(row) : {};
  const link = (typeof col.cellRendererParams.link === 'function') ? col.cellRendererParams.link(row) : col.cellRendererParams.link;

  return <HyperLinkRenderer
    colDef={col}
    value={params}
    link={link}
  />;
};
export const StyledPopupContentRenderer = withStyles(styles, { index: 1 })(PopupContentRenderer);
